import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import { FC } from 'react';

import { AchAuthorizationAcceptance as AchAuthorizationAcceptanceType } from '../../types';

type Props = {
	authorizations: AchAuthorizationAcceptanceType[];
	accepted: boolean;
	onAcceptedChange: (accepted: boolean) => void;
	disabled?: boolean;
};

export const AchAuthorizationAcceptance: FC<Props> = ({
	authorizations,
	accepted,
	onAcceptedChange,
	disabled = false,
}) => {
	if (!authorizations.length) {
		return null;
	}

	const recurring = authorizations.every(({ authorizationType }) => authorizationType === 'Recurring');

	return (
		<Box sx={{ mt: 2, maxWidth: 900 }} data-cy='ach-authorization-details'>
			<Typography variant='subtitle1' fontWeight='bold'>
				{recurring ? 'Recurring ACH Authorization' : 'One-Time ACH Authorization'}
			</Typography>
			{authorizations.map((authorization, index) => (
				<Typography
					key={`${index}-${authorization.effectiveDate}-${authorization.amountInCents}`}
					variant='body2'
					sx={{ mt: 1, mb: 1 }}
				>
					{authorization.authorizationText}
				</Typography>
			))}
			<FormControlLabel
				control={
					<Checkbox
						checked={accepted}
						onChange={(_event, checked) => onAcceptedChange(checked)}
						disabled={disabled}
						required
						data-cy='ach-authorization-ack-checkbox'
					/>
				}
				label={
					<Typography component='span' variant='body2' fontWeight='bold' color='primary.main'>
						{recurring
							? 'I have read and agree to this recurring ACH debit authorization.'
							: 'I have read and authorize this one-time ACH debit.'}
					</Typography>
				}
			/>
		</Box>
	);
};
